import type { ReactNode } from "react";
import { categories } from "@/mocks/suye";

export const catName = (id: string) => categories.find((c) => c.id === id)?.name || "其他";

export interface HeadingProps {
  kicker: string;
  title: ReactNode;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ kicker, title, desc, action }: HeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] text-primary-600 uppercase">
          <span className="h-px w-6 bg-primary-500" />
          {kicker}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}